<template>
  <div class="attachment">
    <div class="form-group">
      <label class="form-control-sm">To:</label>
      <textarea @input="updateTo" :value="currentNode.attachment.to" class="form-control form-control-sm"></textarea>
    </div>
    <div class="form-group">
      <label class="form-control-sm">Subject:</label>
      <textarea @input="updateSubject" :value="currentNode.attachment.subject" class="form-control form-control-sm"></textarea>
    </div>
    <div class="form-group">
      <label class="form-control-sm">Content:</label>
      <textarea @input="updateContent" :value="currentNode.attachment.content" class="form-control form-control-sm"></textarea>
    </div>
  </div>
</template>

<script>
import { formBase } from './mixins'

export default {
  mixins: [formBase],
  methods: {
    updateTo(event) {
      let currentNode = Object.assign({}, this.currentNode)
      currentNode.attachment.to = event.target.value
      this.updateNode(currentNode)
    },
    updateSubject() {
      let currentNode = Object.assign({}, this.currentNode)
      currentNode.attachment.subject = event.target.value
      this.updateNode(currentNode)
    },
    updateContent() {
      let currentNode = Object.assign({}, this.currentNode)
      currentNode.attachment.content = event.target.value
      this.updateNode(currentNode)
    }
  },
  created() {
    if (_.isEmpty(this.currentNode.attachment)) {
      let updatedNode = Object.assign({}, this.currentNode, {attachment: {to: '', subject: '', content: ''}})
      this.updateNode(updatedNode)
    }
  }
}
</script>

<style>

</style>